import { render } from "./NPopUp.vue?vue&type=template&id=34c2507f"
import script from "./NPopUp.vue?vue&type=script&lang=js"
export * from "./NPopUp.vue?vue&type=script&lang=js"

import "./NPopUp.vue?vue&type=style&index=0&id=34c2507f&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__